import { render } from "./colorPalette.vue?vue&type=template&id=3bfe1a6a&scoped=true"
import script from "./colorPalette.vue?vue&type=script&lang=js"
export * from "./colorPalette.vue?vue&type=script&lang=js"

import "./colorPalette.less?vue&type=style&index=0&id=3bfe1a6a&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bfe1a6a"]])

export default __exports__